import { useState } from "react";

import useAsyncModalConfirm from "../asyncModalConfirm/asyncModalConfirm";
import useAsyncModalConfirmReason from "../asyncModalConfirmReason/asyncModalConfirmReason";
import { ReasonTypeEnum } from "@/main/services/enum/ReasonEnum";
import { toBase64 } from "@/main/services/utilsFile";
import { companyManufacturerApi } from "@/main/api";
import { CompanyManufacturerResponse } from "@/main/models/response/companyManufacturerResponse";
import { getTranslateByKey, isNullUndefined } from "@/main/services/utils";
import { toast } from "react-toastify";

// Components
import { IconButton, TableCell, TableRow } from "@mui/material";
import LoadingComponent from "../loading/loadingComponent";
import Close from "@mui/icons-material/Close";

interface IRowCompanyManufacturer {
	companyManufacturer: CompanyManufacturerResponse;
	onRemove: (guidManufacturer: string) => void;
}

function RowCompanyManufacturer({ companyManufacturer, onRemove }: IRowCompanyManufacturer) {
	const [isLoadingRemove, setIsLoadingRemove] = useState<boolean>(false);
	const [getConfirmation, ModalConfirmation] = useAsyncModalConfirm();
	const [getConfirmationReason, ModalConfirmationReason] = useAsyncModalConfirmReason();

	async function handleRemoveManufacturer() {
		if (isNullUndefined(companyManufacturer.guid)) {
			return;
		}

		const message = getTranslateByKey("information.confirmRemoveValuatorManufacturer").replace(
			"{0}",
			companyManufacturer.vehicleManufacturerResponse.vehicleManufacturerName,
		);

		const isConfirmed = await getConfirmation(message);
		if (!isConfirmed) return;

		const resultConfirm = await getConfirmationReason(
			getTranslateByKey("information.confirmChangeTitle"),
			ReasonTypeEnum.ChangeCompany,
		);

		if (!resultConfirm.confirmed) return;

		setIsLoadingRemove(true);

		let filesRequest = undefined;
		if (resultConfirm.files && resultConfirm.files.length > 0) {
			filesRequest = await Promise.all(
				resultConfirm.files.map(async (item) => {
					const base64DataUrl = await toBase64(item);
					return {
						fileName: item.name,
						contentType: item.type,
						fileBase64: base64DataUrl as string,
					};
				}),
			);
		}

		const payload = {
			guidCompanyManufacturer: companyManufacturer.guid,
			changeJustification: {
				guidReason: resultConfirm.reason ? String(resultConfirm.reason.key) : null,
				reasonDescription: resultConfirm.observation || null,
				filesUpload: filesRequest,
			},
		};

		companyManufacturerApi.deleteCompanymanufacturer(payload).then((res) => {
			const resData = res.data.result;

			if (!isNullUndefined(resData)) {
				setIsLoadingRemove(false);
				toast.success(getTranslateByKey("information.companyManufacturerRemovedSucessfully"));
				onRemove(companyManufacturer.guid);
			}
		});
	}

	return (
		<TableRow key={companyManufacturer.guid}>
			<TableCell width="60%">{companyManufacturer.vehicleManufacturerResponse.vehicleManufacturerName}</TableCell>
			<TableCell width="1%" align="center">
				<IconButton
					id={`id-companyManufacturer-btn-remove-${companyManufacturer.vehicleManufacturerResponse.vehicleManufacturerName}`}
					style={{ width: 24, height: 24, padding: 0 }}
					onClick={() => {
						handleRemoveManufacturer();
					}}
				>
					{isLoadingRemove ? <LoadingComponent size={16} /> : <Close style={{ color: "#000" }} />}
				</IconButton>
			</TableCell>
			<ModalConfirmation />
			<ModalConfirmationReason />
		</TableRow>
	);
}

export default RowCompanyManufacturer;
